module.exports = __webpack_public_path__ + "img/cover.8b9459e2.png";